export default __webpack_public_path__ + "static/media/enrolled.f52f3926.png";